import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import { STREAM_ROUTER_ROOT } from './../constants';
import CreateNewComponent from './StreamNew';
import { streamAction } from '../../../../actions/stream/liveStadiumStream';

// new way of actions. Has to have less memory in use;
let CRUDActions = streamAction;

export default connect(
  // eslint-disable-next-line no-unused-vars
  ({ liveStadiumStream: { loadingItem, model } }) => ({
    title: 'Create Stream',
    loading: loadingItem
  }),
  dispatch => ({
    fetch: () => dispatch(CRUDActions.createModel()),
    goIndex: () => dispatch(push(STREAM_ROUTER_ROOT))
  }),
)(CreateNewComponent);



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamNew/index.js